<button class="bg-white w-full flex justify-center items-center gap-0 md:gap-1 lg:gap-1 flex-col py-4 md:py-5 lg:py-5 hover:bg-[#DEF0FF] cursor-pointer" (click)="categorySelect(category())">
  <div class="flex text-[#00538B] text-base font-semibold ">{{category()}}</div>
  <div class="flex text-[#374151] text-xs font-normal">{{services()}} @if(services() <=1 ) { {{getText().service}} } @else{ {{getText().services}} }</div>
</button>
